export var TOKEN_SUCCESSFUL = 'TOKEN_SUCCESSFUL';
export var TOKEN_FAILURE = 'TOKEN_FAILURE';
export var TOKEN_CLEAR = 'TOKEN_CLEAR';
